import { Block, type IconNames, palette, SvgIcon, spacing, Typography } from "@stepapp/ui";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";

const iconMapping: Record<"training" | "safety", IconNames> = {
  training: "certificate",
  safety: "verified-big",
};

type Props = {
  type: "training" | "safety";
  name: string;
};

const WorkerBadge = ({ type, name }: Props) => {
  const { t } = useTranslation();

  return (
    <Block
      justifySpace
      row
      borderRadius={1}
      marginVertical={1}
      paddingHorizontal={2.5}
      paddingVertical={1.5}
      style={styles.container}
    >
      <Block justifyCenter style={styles.iconContainer}>
        <SvgIcon name={iconMapping[type]} color={palette.primary.accent} />
      </Block>
      <Block marginLeft={2} flex={8}>
        <Typography variant="label">
          {t("screens.predefinedProfile.workerBadgeTitle", {
            context: type,
            name,
          })}
        </Typography>
        <Typography variant="lightLabel">
          {t("screens.predefinedProfile.workerBadgeDescription", {
            context: type,
            name,
          })}
        </Typography>
      </Block>
    </Block>
  );
};

export default WorkerBadge;

const styles = StyleSheet.create({
  container: {
    backgroundColor: palette.secondary.main,
  },
  iconContainer: {
    width: spacing.unit * 4,
  },
});
